<template>
  <div class="manage">
    <div class="header">
      <el-form label-width="auto" :model="searchForm.formData"
               :inline="true" size="mini" class="search-form">
        <el-form-item label="车辆编号" prop="code">
          <el-input
            placeholder="请输入车辆编号"
            v-model.trim="searchForm.formData.code"
            prefix-icon="el-icon-search"
          />
        </el-form-item>
        <el-date-picker
          v-model="searchForm.formData.dateRange"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['6:00:00','6:00:00']">
        </el-date-picker>
        <el-form-item>
          <el-button type="primary" @click="search" size="mini">搜索 <i class="el-icon-search"/></el-button>
          <el-button type="danger" @click="reset" size="mini">重置 <i class="el-icon-refresh-left"/></el-button>
          <el-button type="danger" @click="updateProduction" size="mini">更新5日内数据 <i class="el-icon-refresh-left"></i></el-button>
        </el-form-item>
      </el-form>
    </div>

    <!------------------------ 数据表格 ----------------------->
    <div class="common-table">
      <el-table
        v-loading="loading1"
        element-loading-text="拼命加载中"
        :data="table.tableData"
        height="85%"
        border
        stripe
        row-key="id"
        :header-cell-style="{background: '#eef1f6',color: '#606266',
        textAlign:'center',fontWeight:'bold',borderWidth:'3px'}"
      >
        <el-table-column prop="code" label="车辆编号" min-width="20" align="center">
          <template slot-scope="{ row }">
            <div class="table-cell">
              {{ row.code }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="生产时间" min-width="30" align="center" />
        <el-table-column prop="type" label="生产类型" min-width="30" align="center" >
          <template slot-scope="scope">
            {{ scope.row.type === 1 ? '1号小卡机' : (scope.row.type === 2 ? '1号计量仪' : (scope.row.type === 3 ? '2号计量仪' : (scope.row.type === 4 ? '3号计量仪' : '新卡机'))) }}
          </template>
        </el-table-column>
        <el-table-column prop="imageUrl" label="图片" min-width="80" align="center" >
          <template slot-scope="scope">
            <img :src="scope.row.imageUrl" loading="lazy" onerror="this.src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTd24wQRc9atSbID4ySXsMKKuGVvS7Xf-ZP4Q&usqp=CAU'" alt="Image" class="image-preview" @click="showImage(scope.row.imageUrl)" />
          </template>
        </el-table-column>
      </el-table>

      <!-- 弹出的 Dialog 对话框 -->
      <el-dialog :visible.sync="dialogVisible" width="50%">
        <img :src="dialogImageUrl" alt="Image" class="dialog-image" />
        <div class="dialog-controls">
          <el-button @click="prevImage" size="mini">上一张</el-button>
          <el-button @click="nextImage" size="mini">下一张</el-button>
        </div>
      </el-dialog>

      <el-pagination
        class="pager"
        layout="total,sizes,prev,pager,next,jumper"
        :page-size="table.pageConfig.size ? table.pageConfig.size : 10"
        :page-sizes="[10, 50, 100, 200, 4000]"
        :total="table.pageConfig.total"
        :current-page.sync="table.pageConfig.current"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {getList, updateAll} from '@/api/production'

export default {
  name: 'Car',
  data () {
    const now = new Date() // 获取当前日期时间
    const yesterday = new Date(now) // 复制当前日期时间
    yesterday.setDate(yesterday.getDate() - 1) // 计算昨天的日期
    // 格式化日期为指定格式
    function formatDateToYYYYMMDDHHMMSS (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    }
    return {
      loading1: false,
      searchForm: {
        deptList: [],
        formData: {
          dateRange: [formatDateToYYYYMMDDHHMMSS(new Date(yesterday.setHours(6, 0, 0))), formatDateToYYYYMMDDHHMMSS(new Date(now))]
        }
      },
      dialogVisible: false,
      dialogImageUrl: '',
      currentImageIndex: 0,
      table: {
        tableData: [],
        pageConfig: {
          total: 10, // 记录总数
          current: 1, // 起始页
          size: 10 // 每页展示的记录数
        }
      }
    }
  },
  methods: {
    updateProduction() {
      this.loading1 = true
      updateAll({myDeptId: this.$store.state.staff.staff.deptId}).then((res) => {
        if (res.code === 200) {
          this.$message.success('更新成功！')
          this.loading()
        } else {
          this.$message.error('更新失败！')
        }
        this.loading1 = false
      })
    },
    formatDateToYYYYMMDDHHMMSS (date1) {
      const date = new Date(date1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    },
    loading () {
      const a = this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[0])
      const b = this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[1])
      this.searchForm.formData.dateRange = [a, b]
      getList({
        current: this.table.pageConfig.current,
        size: this.table.pageConfig.size,
        code: this.searchForm.formData.code,
        startTime: this.searchForm.formData.dateRange[0],
        endTime: this.searchForm.formData.dateRange[1],
        isGroup: false,
        deptId: this.$store.state.staff.staff.deptId
      }).then(response => {
        if (response.code === 200) {
          this.table.tableData = response.data.list
          this.table.pageConfig.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      })
    },
    showImage (url) {
      this.dialogImageUrl = url
      this.dialogVisible = true
      this.currentImageIndex = this.table.tableData.findIndex(item => item.imageUrl === url)
    },
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--
        this.dialogImageUrl = this.table.tableData[this.currentImageIndex].imageUrl
      }
    },
    nextImage() {
      if (this.currentImageIndex < this.table.tableData.length - 1) {
        this.currentImageIndex++
        this.dialogImageUrl = this.table.tableData[this.currentImageIndex].imageUrl
      }
    },
    handleSizeChange (size) {
      this.table.pageConfig.size = size
      this.loading()
    },
    handleCurrentChange (current) {
      this.table.pageConfig.current = current
      this.loading()
    },
    search () {
      this.loading()
    },
    reset () {
      this.searchForm.formData = {}
      this.loading()
    }
  },
  created () {
    this.loading()
  }
}
</script>

<style scoped lang="less">
.manage {
  padding: 20px;
  background: linear-gradient(135deg, #f0f2f5, #e0e7ff);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  margin-bottom: 15px;
  text-align: left;
}

.manage-header {
  margin-bottom: 20px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.search-form {
  margin: 15px 0;
}

.common-table {
  background-color: white;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table-cell {
  min-height: 63px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview {
  max-width: 100px;
  max-height: 100px;
  cursor: zoom-in;
  transition: transform 0.2s;
  border-radius: 8px;
}

.image-preview:hover {
  transform: scale(1.1);
}

.dialog-image {
  max-width: 100%;
  border-radius: 12px;
}

.dialog-controls {
  text-align: center;
  margin-top: 10px;
}

.el-button {
  border-radius: 8px;
  transition: background-color 0.3s, color 0.3s;
}

.el-button:hover {
  background-color: #409eff;
  color: white;
}
</style>
